const RequestType = {
	CREATE: 'PUT',
	READ: 'GET',
	READ_ALL: 'GET_ALL',
	UPDATE: 'POST',
	DELETE: 'DELETE',
};

export default RequestType;